














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class TableHeaderSorter extends Vue {
    @Prop() value!: string;
    @Prop() orderBy!: string;
    @Prop() orderWay!: 'ASC' | 'DESC' | null;
}
